import {
  HeaderConfigSnapshot,
  HeaderMenuItem,
  HeaderSession,
  HeaderTheme,
  HeaderVariant
} from '../contracts/header';
import { ConfigClient } from './config-client';
import { DEFAULT_HEADER_CONFIG } from './default-menu';
import { getConfig, initConfig } from '../core/config';
import { logout as logoutAuth, setUserConfig } from '../core/auth';
import { bindGaUser, initAnalytics } from '../core/analytics';
import { subscribeToSessionSync } from '../core/session-sync';
import type { SessionSyncDetail } from '../core/session-sync';
import { escapeHtml, safeCssColor, safeUrl, sanitizeSvg } from '../core/sanitize';

type AuthDialogElement = HTMLElement & {
  open: (mode: 'login' | 'register') => void;
  configure?: (options: { providers?: string[]; registrationEnabled?: boolean; privacyUrl?: string; termsUrl?: string }) => void;
};

const FIGMA_COINS_ICON = `<svg class="credits-button-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.8333 14.1198C15.5755 14.2563 15.2977 14.3806 15.0062 14.4899C13.6844 14.9855 11.9144 15.275 10.0003 15.2751C8.08599 15.2751 6.31539 14.9856 4.99349 14.4899C4.70191 14.3806 4.42424 14.2564 4.16634 14.1198V15.8337C4.16643 15.8558 4.17676 15.9761 4.41048 16.1833C4.64443 16.3906 5.03026 16.6154 5.57845 16.821C6.66939 17.2301 8.23285 17.4997 10.0003 17.4997C11.7675 17.4996 13.3304 17.23 14.4212 16.821C14.9697 16.6153 15.3562 16.3906 15.5902 16.1833C15.8239 15.9761 15.8332 15.8558 15.8333 15.8337V14.1198ZM15.8333 10.234C15.5756 10.3705 15.2976 10.4939 15.0062 10.6032C13.6844 11.0988 11.9145 11.3883 10.0003 11.3883C8.08591 11.3883 6.31541 11.0989 4.99349 10.6032C4.70197 10.4939 4.42419 10.3706 4.16634 10.234V11.9421L4.17122 11.9762C4.18468 12.0288 4.23447 12.1356 4.41048 12.2917C4.64444 12.4989 5.03027 12.7238 5.57845 12.9294C6.66939 13.3385 8.23285 13.6081 10.0003 13.6081C11.7675 13.608 13.3304 13.3384 14.4212 12.9294C14.9697 12.7237 15.3562 12.499 15.5902 12.2917C15.7661 12.1357 15.815 12.0288 15.8285 11.9762L15.8333 11.9421V10.234ZM15.8333 6.3444C15.5755 6.48096 15.2977 6.60519 15.0062 6.71452C13.6844 7.21013 11.9145 7.49964 10.0003 7.49967C8.08593 7.49967 6.3154 7.21022 4.99349 6.71452C4.70185 6.60515 4.42428 6.48102 4.16634 6.3444V8.05534C4.16634 8.07662 4.1756 8.1967 4.41048 8.40495C4.64439 8.61227 5.03015 8.83701 5.57845 9.04264C6.66939 9.45175 8.23285 9.72233 10.0003 9.72233C11.7676 9.7223 13.3304 9.4517 14.4212 9.04264C14.9698 8.83694 15.3563 8.61234 15.5902 8.40495C15.7665 8.24855 15.8152 8.14189 15.8285 8.08952L15.8333 8.05534V6.3444ZM15.8333 4.16667C15.8333 4.14539 15.8249 4.02525 15.5902 3.81706C15.3563 3.60967 14.9698 3.38507 14.4212 3.17936C13.3304 2.77031 11.7676 2.49971 10.0003 2.49967C8.23285 2.49967 6.66939 2.77026 5.57845 3.17936C5.03019 3.38498 4.6444 3.60975 4.41048 3.81706C4.1756 4.02531 4.16634 4.14539 4.16634 4.16667C4.16634 4.18794 4.1756 4.30803 4.41048 4.51628C4.6444 4.72358 5.03019 4.94836 5.57845 5.15397C6.66939 5.56307 8.23285 5.83366 10.0003 5.83366C11.7676 5.83363 13.3304 5.56302 14.4212 5.15397C14.9698 4.94827 15.3563 4.72367 15.5902 4.51628C15.8249 4.30809 15.8333 4.18794 15.8333 4.16667ZM17.5003 15.8337C17.5002 16.5026 17.1354 17.0405 16.6956 17.4303C16.2549 17.8211 15.664 18.1348 15.0062 18.3815C13.6844 18.8771 11.9144 19.1666 10.0003 19.1667C8.08598 19.1667 6.31539 18.8772 4.99349 18.3815C4.3356 18.1348 3.74482 17.8211 3.30404 17.4303C2.8643 17.0405 2.50044 16.5026 2.50033 15.8337V4.16667C2.50033 3.49769 2.8643 2.95992 3.30404 2.56999C3.74482 2.17919 4.3356 1.86552 4.99349 1.61882C6.3154 1.12311 8.08593 0.833659 10.0003 0.833659C11.9145 0.833692 13.6844 1.1232 15.0062 1.61882C15.6641 1.86552 16.2549 2.17919 16.6956 2.56999C17.1355 2.95993 17.5003 3.49759 17.5003 4.16667V15.8337Z" fill="#FDFDFD"/></svg>`;
const FIGMA_GIFT_ICON = `<svg width="36" height="36" viewBox="0 0 35.3333 35.3333" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.6667 7.66667V34.3333M17.6667 7.66667H11.7738C10.9055 7.66667 10.0728 7.31548 9.45888 6.69036C8.84492 6.06523 8.5 5.21739 8.5 4.33333C8.5 3.44928 8.84492 2.60143 9.45888 1.97631C10.0728 1.35119 10.9055 1 11.7738 1C16.3571 1 17.6667 7.66667 17.6667 7.66667ZM17.6667 7.66667H23.5595C24.4278 7.66667 25.2605 7.31548 25.8745 6.69036C26.4884 6.06523 26.8333 5.21739 26.8333 4.33333C26.8333 3.44928 26.4884 2.60143 25.8745 1.97631C25.2605 1.35119 24.4278 1 23.5595 1C18.9762 1 17.6667 7.66667 17.6667 7.66667ZM31 16V29C31 30.8668 31 31.8003 30.6367 32.5133C30.3171 33.1405 29.8072 33.6504 29.18 33.97C28.4669 34.3333 27.5335 34.3333 25.6667 34.3333L9.66667 34.3333C7.79983 34.3333 6.86641 34.3333 6.15337 33.97C5.52616 33.6504 5.01622 33.1405 4.69665 32.5133C4.33334 31.8003 4.33334 30.8668 4.33334 29V16M1 10.3333L1 13.3333C1 14.2668 1 14.7335 1.18166 15.09C1.34145 15.4036 1.59641 15.6586 1.91002 15.8183C2.26654 16 2.73325 16 3.66667 16L31.6667 16C32.6001 16 33.0668 16 33.4233 15.8183C33.7369 15.6586 33.9919 15.4036 34.1517 15.09C34.3333 14.7335 34.3333 14.2668 34.3333 13.3333V10.3333C34.3333 9.39991 34.3333 8.9332 34.1517 8.57668C33.9919 8.26308 33.7369 8.00811 33.4233 7.84832C33.0668 7.66667 32.6001 7.66667 31.6667 7.66667L3.66667 7.66667C2.73325 7.66667 2.26654 7.66667 1.91002 7.84832C1.59642 8.00811 1.34145 8.26308 1.18166 8.57668C1 8.9332 1 9.39991 1 10.3333Z" stroke="#FF2D9E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const FIGMA_PLAN_ICON = `<svg width="18" height="16" viewBox="0 0 17.5 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.81817 0.49386L8.74998 0L13.6818 0.49386L17.5 5.34875L8.74998 14.9999L0 5.34875L3.81817 0.49386Z" fill="#FAC515"/><path d="M3.54414 5.34876L8.74994 15L0 5.34876H3.54414ZM13.9559 5.34876L8.75006 15L17.5 5.34876" fill="#FF4405"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3.54414 5.34876H13.9557L8.74994 15" fill="#FAC515"/><path d="M8.74994 0L3.81813 0.493777L3.54414 5.3487L8.74994 0ZM8.75002 0L13.6818 0.493777L13.9558 5.3487" fill="#EAAA08"/><path d="M17.5 5.34869L13.6819 0.49376L13.9559 5.34869H17.5ZM0 5.34869L3.81813 0.49376L3.54414 5.34869" fill="#FAC515"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.74994 0L3.54414 5.3487H13.9557" fill="#854A0E"/></svg>`;
const FIGMA_CROWN_ICON = `<svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.9921 4.98028L19.2141 15.6991C19.1328 15.8815 18.9438 16 18.7344 16H5.26559C5.05618 16 4.86714 15.8814 4.78588 15.6991L0.00787979 4.98028C-0.0256682 4.90503 0.0538684 4.82903 0.133897 4.85987L8.10891 7.93432L11.9118 0.0536106C11.9463 -0.0178702 12.0538 -0.0178702 12.0882 0.0536106L15.8911 7.93432L23.8661 4.85987C23.9461 4.82903 24.0257 4.90503 23.9921 4.98028Z" fill="#FF2D9E"/></svg>`;
const FIGMA_DISCORD_ICON = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAAR1JREFUeAHtUz1PAkEQfWusvLWEu8YCJbES/Q8SsMJ4NiYmdCZ+NCYWFjZaa2GjFnYaSiChgiPwHwgthJaP9pZ2mV3IcnCBhoKGl1x2bnb2zby3WebsHUqsgC2siPUTbM8nLi8yOIjvQ0oJIYTOUQjGgFa7A8+rLSZIp05xf3eDReh2B3oNksxISBHBMjhOBGdzNYaAcwsniaNxp14P5UCXfLFEub6Oj6mGW1aYQOk2BwolvH98as2NZhPfP7/4+8+Z/cSkkYLxIB6LmaTywh8KOLZNfxG4bgbpZDIgJRqewPf9yfh9igWenx5J1g59HA+3ZCyTRobaD01Qqdb1ms1eaz/O3SvYdlQXq+t8e30B3+X4IjledeoP27wFjAAys1qDH5hlAQAAAABJRU5ErkJggg==';

const BUILTIN_LIGHT_LOGOS = new Map<string, string>([
  ['VidAU', 'VidAU dark.svg'],
  ['VidAU creative white', 'VidAU creative dark.svg'],
  ['VidAU crew white', 'VidAU crew dark.svg'],
  ['VidAU media white', 'VidAU media dark.svg'],
  ['VidAU router white', 'VidAU router dark.svg'],
  ['VidAU studio white', 'VidAU studio dark.svg'],
]);

const EXPANDED_HEADER_HEIGHT = 54;
const STUCK_HEADER_HEIGHT = 36;

export class VidauHeader extends HTMLElement {
  private shadow: ShadowRoot;
  private config: HeaderConfigSnapshot = DEFAULT_HEADER_CONFIG;
  private session: HeaderSession = { authenticated: false };
  private activeDropdownId: string | null = null;
  private isMobileMenuOpen: boolean = false;
  private lastIsMobile = false;
  private visibilityTimer: number | null = null;
  private unsubscribeSessionSync: (() => void) | null = null;
  private sessionRefreshPromise: Promise<HeaderSession> | null = null;
  private sessionSyncRevision = 0;
  private scrollFrame: number | null = null;
  private headerResizeObserver: ResizeObserver | null = null;
  private connectionRevision = 0;

  static get observedAttributes() {
    return ['app-id', 'locale', 'variant', 'theme', 'config-url', 'logo', 'logo-light', 'logo-dark', 'env', 'api-base-url'];
  }

  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: 'open' });
  }

  get logo(): string {
    return this.getAttribute('logo') || 'VidAU';
  }

  get logoLight(): string | null {
    return this.getAttribute('logo-light');
  }

  get logoDark(): string | null {
    return this.getAttribute('logo-dark');
  }

  get appId(): string {
    return (this.getAttribute('app-id') || '').trim();
  }
  get locale(): string {
    return this.getAttribute('locale') || 'en-US';
  }
  get variant(): HeaderVariant {
    return (this.getAttribute('variant') as HeaderVariant) || 'full';
  }
  get theme(): HeaderTheme {
    return (this.getAttribute('theme') as HeaderTheme) || 'dark';
  }
  get configUrl(): string | undefined {
    return this.getAttribute('config-url') || undefined;
  }
  get environment(): 'production' | 'development' | undefined {
    const env = this.getAttribute('env');
    return env === 'production' || env === 'development' ? env : undefined;
  }
  get apiBaseUrl(): string | undefined {
    const url = safeUrl(this.getAttribute('api-base-url'), false);
    if (!url) return undefined;
    return url.endsWith('/') ? url : `${url}/`;
  }

  private _isConnected = false;
  private static SESSION_CACHE_KEY = 'vidau_hdr_session';
  private static SESSION_CACHE_TTL = 10 * 60 * 1000; // 10 分钟

  /** 从 sessionStorage 读取会话缓存 */
  private readSessionCache(): HeaderSession | null {
    try {
      const raw = sessionStorage.getItem(VidauHeader.SESSION_CACHE_KEY);
      if (!raw) return null;
      const { session, ts } = JSON.parse(raw);
      if (Date.now() - ts > VidauHeader.SESSION_CACHE_TTL) {
        sessionStorage.removeItem(VidauHeader.SESSION_CACHE_KEY);
        return null;
      }
      return session;
    } catch {
      return null;
    }
  }

  /** 写入会话缓存 */
  private writeSessionCache(session: HeaderSession) {
    try {
      sessionStorage.setItem(
        VidauHeader.SESSION_CACHE_KEY,
        JSON.stringify({ session, ts: Date.now() })
      );
    } catch { /* ignore */ }
  }

  private applySession(session: HeaderSession) {
    this.session = session;
    if (session.authenticated) this.writeSessionCache(session);
    else sessionStorage.removeItem(VidauHeader.SESSION_CACHE_KEY);
    bindGaUser(session.authenticated ? session.user?.id : null);
    this.render();
    this.setupListeners();
  }

  private refreshSessionAfterChange(): Promise<HeaderSession> {
    if (this.sessionRefreshPromise) return this.sessionRefreshPromise;

    const revision = this.sessionSyncRevision;
    const refreshPromise: Promise<HeaderSession> = this.fetchSession()
      .then((session) => {
        if (this._isConnected && revision === this.sessionSyncRevision) {
          this.applySession(session);
          this.dispatchEventCustom('vidau:session-changed', { authenticated: session.authenticated });
        }
        return session;
      })
      .finally(() => {
        if (this.sessionRefreshPromise === refreshPromise) this.sessionRefreshPromise = null;
      });
    this.sessionRefreshPromise = refreshPromise;
    return refreshPromise;
  }

  private handleSessionSync = (detail: SessionSyncDetail) => {
    if (!this._isConnected || !this.appId || detail.appId !== this.appId) return;

    if (detail.authenticated) {
      void this.refreshSessionAfterChange();
      return;
    }

    this.sessionSyncRevision += 1;
    this.sessionRefreshPromise = null;
    this.applySession({ authenticated: false });
    this.dispatchEventCustom('vidau:session-changed', { authenticated: false });
  };

  async connectedCallback() {
    this._isConnected = true;
    const connectionRevision = ++this.connectionRevision;
    this.configureAuth();
    initAnalytics();
    this.unsubscribeSessionSync = subscribeToSessionSync(this.handleSessionSync);
    this.lastIsMobile = this.isMobileViewport();
    window.addEventListener('scroll', this.handleScroll, { capture: true, passive: true });
    this.headerResizeObserver = new ResizeObserver(this.handleScroll);
    this.headerResizeObserver.observe(this);

    // 尝试从缓存瞬时渲染（Stale-While-Revalidate）
    const cachedSession = this.readSessionCache();
    const hasCachedConfig = ConfigClient.hasCachedConfig(this.configUrl, this.locale, this.environment);

    if (hasCachedConfig && cachedSession) {
      // 有缓存 → 跳过骨架屏，直接瞬时渲染
      this.config = await ConfigClient.fetchConfig(this.configUrl, this.locale, this.environment);
      if (!this._isConnected || connectionRevision !== this.connectionRevision) return;
      this.session = cachedSession;
      this.render();
      this.setupListeners();
      document.addEventListener('click', this.handleDocumentClick);
      window.addEventListener('resize', this.handleResize);
      window.visualViewport?.addEventListener('resize', this.handleResize);
      window.visualViewport?.addEventListener('scroll', this.handleResize);
      this.dispatchEventCustom('vidau:ready', { sdkVersion: '1.0.0', releaseId: this.config.releaseId });

      // 后台静默刷新会话数据
      this.revalidateSession();
    } else {
      // 无缓存 → 走骨架屏 + 完整加载流程
      this.renderSkeleton();
      await this.loadData();
      if (!this._isConnected || connectionRevision !== this.connectionRevision) return;
      this.render();
      this.setupListeners();
      document.addEventListener('click', this.handleDocumentClick);
      window.addEventListener('resize', this.handleResize);
      window.visualViewport?.addEventListener('resize', this.handleResize);
      window.visualViewport?.addEventListener('scroll', this.handleResize);
      this.dispatchEventCustom('vidau:ready', { sdkVersion: '1.0.0', releaseId: this.config.releaseId });
    }
  }

  disconnectedCallback() {
    this._isConnected = false;
    this.connectionRevision += 1;
    window.removeEventListener('scroll', this.handleScroll, true);
    this.headerResizeObserver?.disconnect();
    this.headerResizeObserver = null;
    if (this.scrollFrame !== null) window.cancelAnimationFrame(this.scrollFrame);
    this.scrollFrame = null;
    document.removeEventListener('click', this.handleDocumentClick);
    window.removeEventListener('resize', this.handleResize);
    window.visualViewport?.removeEventListener('resize', this.handleResize);
    window.visualViewport?.removeEventListener('scroll', this.handleResize);
    this.unsubscribeSessionSync?.();
    this.unsubscribeSessionSync = null;
    this.sessionSyncRevision += 1;
    this.sessionRefreshPromise = null;
    if (this.visibilityTimer !== null) window.clearTimeout(this.visibilityTimer);
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (!this._isConnected || oldValue === newValue) return;

    if (name === 'theme' || name === 'variant' || name === 'logo' || name === 'logo-light' || name === 'logo-dark') {
      this.render();
      this.setupListeners();
    }
    if (name === 'config-url' || name === 'locale' || name === 'app-id' || name === 'env' || name === 'api-base-url') {
      this.configureAuth();
      this.loadData().then(() => {
        this.render();
        this.setupListeners();
      });
    }
  }

  private async loadData() {
    // 并行获取菜单配置和 SSO HttpOnly Cookie 会话状态
    const configPromise = ConfigClient.fetchConfig(this.configUrl, this.locale, this.environment);
    const authPromise = this.fetchSession();

    const [config, session] = await Promise.all([configPromise, authPromise]);
    this.config = config;
    this.session = session;

    // 写入 session 缓存
    this.writeSessionCache(this.session);
  }

  /** 后台静默刷新会话（SWR 的 revalidate 阶段） */
  private async revalidateSession() {
    try {
      const freshSession = await this.fetchSession();

      // 仅在数据有变化时才重新渲染
      const changed = JSON.stringify(freshSession) !== JSON.stringify(this.session);
      if (changed) {
        this.session = freshSession;
        this.writeSessionCache(freshSession);
        this.render();
        this.setupListeners();
      } else {
        this.writeSessionCache(freshSession);
      }
    } catch (e) {
      console.warn('[VidAU Header SDK] Revalidation failed:', e);
    }
  }

  private configureAuth() {
    const appId = this.appId;
    if (!appId) return;

    const hostname = window.location.hostname;
    const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
    const env = this.environment || (hostname.includes('vidau.info') || isLocal ? 'development' : 'production');
    const apiBaseUrl = this.apiBaseUrl || (!this.environment && isLocal ? `${window.location.origin}/api/sso/` : undefined);
    initConfig(env, apiBaseUrl ? { apiBaseUrl } : undefined);
    setUserConfig({ appId, env, apiBaseUrl, locale: this.locale, redirectUrl: window.location.href });
  }

  private async fetchSession(): Promise<HeaderSession> {
    if (!this.appId) return { authenticated: false };

    try {
      const response = await fetch(`${getConfig().apiBaseUrl}user-info`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-App-Id': this.appId,
          'X-App-Key': this.appId,
        },
        credentials: 'include',
        body: JSON.stringify({ redirectUrl: window.location.href }),
      });
      if (!response.ok) {
        if (response.status !== 401) {
          this.dispatchEventCustom('vidau:error', {
            code: 'SESSION_FETCH_FAILED',
            message: `Session request failed with status ${response.status}`,
          });
        }
        return { authenticated: false };
      }
      const result = await response.json();
      if (result?.code !== 0 || !result.data) return { authenticated: false };
      const user = result.data;
      const plan = user.plan
        || user.plan_name
        || (this.locale.toLowerCase().startsWith('zh') ? user.vip_name : user.vip_name_en)
        || user.vip_name;
      const credits = Number(user.coin ?? 0);
      const totalCredits = Number(user.total_coin ?? user.totalCoin ?? credits);
      const spentCredits = Number(
        user.spent_coin
        ?? user.spentCoin
        ?? user.used_coin
        ?? user.usedCoin
        ?? Math.max(totalCredits - credits, 0)
      );
      const creditsExpireAt = user.credit_expire_time
        || user.coin_expire_time
        || user.vip_info?.expire_at
        || user.first_order_expire_time;
      return {
        authenticated: true,
        user: {
          id: String(user.id || user.user_id || user.userId || ''),
          displayName: String(user.nickname || user.username || user.email?.split('@')[0] || 'User'),
          email: typeof user.email === 'string' ? user.email : undefined,
          avatarUrl: typeof user.avatar === 'string' ? user.avatar : undefined,
          plan: typeof plan === 'string' ? plan : undefined,
          credits: Number.isFinite(credits) ? credits : 0,
          totalCredits: Number.isFinite(totalCredits) ? totalCredits : 0,
          spentCredits: Number.isFinite(spentCredits) ? spentCredits : 0,
          creditsExpireAt: typeof creditsExpireAt === 'string' ? creditsExpireAt : undefined,
        },
      };
    } catch (error) {
      this.dispatchEventCustom('vidau:error', {
        code: 'SESSION_FETCH_FAILED',
        message: error instanceof Error ? error.message : 'Unable to load the SSO session',
      });
      return { authenticated: false };
    }
  }

  private isMobileViewport(): boolean {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  private handleScroll = () => {
    if (this.scrollFrame !== null) return;
    this.scrollFrame = window.requestAnimationFrame(() => {
      this.scrollFrame = null;
      if (this._isConnected) this.updateStickyState();
    });
  };

  private updateStickyState() {
    let scrollContainer = this.parentElement;
    while (scrollContainer && scrollContainer !== document.body && scrollContainer !== document.documentElement) {
      if (/auto|scroll|hidden|overlay/.test(getComputedStyle(scrollContainer).overflowY)) break;
      scrollContainer = scrollContainer.parentElement;
    }
    const elementScrollContainer = scrollContainer && scrollContainer !== document.body && scrollContainer !== document.documentElement
      ? scrollContainer
      : null;
    const scrollTop = elementScrollContainer?.scrollTop ?? window.scrollY;
    const scrollportTop = elementScrollContainer
      ? elementScrollContainer.getBoundingClientRect().top + elementScrollContainer.clientTop
      : 0;
    const stickyTop = scrollportTop + (Number.parseFloat(getComputedStyle(this).top) || 0);
    // Allow for the height reduction so scroll anchoring cannot reset the
    // scroll position and repeatedly toggle the header on short pages.
    const threshold = this.hasAttribute('data-stuck') ? 0 : EXPANDED_HEADER_HEIGHT - STUCK_HEADER_HEIGHT + 2;
    this.toggleAttribute('data-stuck', scrollTop > threshold && Math.abs(this.getBoundingClientRect().top - stickyTop) <= 1);

    this.positionUserMenu();
    this.shadow.querySelectorAll<HTMLElement>('.nav-list .dropdown-popover.open').forEach((dropdown) => {
      const item = dropdown.closest('.nav-item');
      if (!item) return;
      const rect = item.getBoundingClientRect();
      dropdown.style.position = 'fixed';
      dropdown.style.top = `${rect.bottom + 2}px`;
      dropdown.style.left = `${rect.left}px`;
    });
    const overlay = this.shadow.querySelector<HTMLElement>('.mobile-menu-overlay');
    if (overlay) {
      overlay.style.setProperty('--header-overlay-top', `${Math.max(0, this.getBoundingClientRect().bottom)}px`);
    }
  }

  private handleResize = () => {
    const isMobile = this.isMobileViewport();
    if (isMobile !== this.lastIsMobile) {
      this.lastIsMobile = isMobile;
      this.render();
      this.setupListeners();
      return;
    }
    this.updateStickyState();
  };

  private positionUserMenu() {
    const popover = this.shadow.querySelector('#user-dropdown') as HTMLElement | null;
    const trigger = this.shadow.querySelector('#user-avatar-trigger') as HTMLElement | null;
    if (!popover?.classList.contains('open') || !trigger) return;
    const margin = 8;
    const host = this.getBoundingClientRect();
    const rect = trigger.getBoundingClientRect();
    const width = Math.min(345, Math.max(0, host.width - margin * 2));
    let right = host.right - rect.right;
    right = Math.max(margin, right);
    if (host.width - right - width < margin) {
      right = Math.max(margin, host.width - width - margin);
    }
    popover.style.position = 'absolute';
    popover.style.top = `${rect.bottom - host.top + 12}px`;
    popover.style.right = `${right}px`;
    popover.style.left = 'auto';
    popover.style.width = `${width}px`;
    popover.style.maxWidth = `${Math.max(0, host.width - margin * 2)}px`;
    popover.style.transform = 'none';
  }

  private clearUserMenuPosition(popover: HTMLElement) {
    popover.style.position = '';
    popover.style.top = '';
    popover.style.right = '';
    popover.style.left = '';
    popover.style.width = '';
    popover.style.maxWidth = '';
    popover.style.transform = '';
  }

  private dispatchEventCustom(eventName: string, detail?: unknown) {
    this.dispatchEvent(
      new CustomEvent(eventName, {
        detail,
        bubbles: true,
        composed: true
      })
    );
  }

  /**
   * Let the full SSO SDK claim the pricing action. A standalone Header keeps
   * its normal link navigation when the SDK is not present on the host page.
   */
  private requestPricing(source: string) {
    return !this.dispatchEvent(
      new CustomEvent('vidau:pricing-open', {
        detail: { source },
        bubbles: true,
        composed: true,
        cancelable: true,
      })
    );
  }

  private handleDocumentClick = () => {
    this.shadow.querySelectorAll('.header-account-popover.open').forEach((popover) => {
      popover.classList.remove('open');
      if (popover.id === 'user-dropdown') this.clearUserMenuPosition(popover as HTMLElement);
    });
  };

  private getHostLayoutStyles(): string {
    return `
      :host {
        --header-height: ${EXPANDED_HEADER_HEIGHT}px;
        display: block;
        width: 100%;
        height: var(--header-height);
        box-sizing: border-box;
        position: sticky;
        top: 0;
        z-index: 2147483647;
        background: transparent;
        border-bottom: 1px solid transparent;
        transition: height 180ms ease, background-color 180ms ease, border-color 180ms ease;
      }
      :host([data-stuck]) {
        --header-height: ${STUCK_HEADER_HEIGHT}px;
        background: var(--bg-primary);
        border-bottom-color: var(--border-color);
      }
      @media (prefers-reduced-motion: reduce) {
        :host { transition: none; }
      }
    `;
  }

  private renderSkeleton() {
    const isDark = this.theme === 'dark';
    this.shadow.innerHTML = `
      <style>
        ${this.getHostLayoutStyles()}
        :host {
          --bg-primary: ${isDark ? '#0a0d12' : '#ffffff'};
          --border-color: ${isDark ? '#26293b' : '#e2e8f0'};
        }
        .skeleton-container {
          width: 100%;
          max-width: var(--header-max-width, 100%);
          margin: 0 auto;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: var(--header-padding, 0 40px);
          box-sizing: border-box;
        }
        .skeleton-left {
          display: flex;
          align-items: center;
          gap: 48px;
        }
        .skeleton-nav {
          display: flex;
          gap: 20px;
        }
        .skeleton-right {
          display: flex;
          gap: 16px;
        }
        .shimmer {
          background: ${isDark ? '#1c1e26' : '#eef1f8'};
          border-radius: 4px;
          overflow: hidden;
          position: relative;
        }
        .shimmer::after {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 50%;
          height: 100%;
          background: linear-gradient(90deg, transparent, ${isDark ? 'rgba(255, 255, 255, 0.04)' : 'rgba(255, 255, 255, 0.6)'}, transparent);
          animation: loading 1.5s infinite;
        }
        @keyframes loading {
          0% { left: -100%; }
          100% { left: 200%; }
        }

        @media (max-width: 768px) {
          .skeleton-nav { display: none; }
        }
      </style>
      <div class="skeleton-container">
        <div class="skeleton-left">
          <div class="shimmer" style="width: 50px; height: 17px;"></div>
          <div class="skeleton-nav">
            <div class="shimmer" style="width: 60px; height: 20px;"></div>
            <div class="shimmer" style="width: 50px; height: 20px;"></div>
            <div class="shimmer" style="width: 70px; height: 20px;"></div>
            <div class="shimmer" style="width: 60px; height: 20px;"></div>
          </div>
        </div>
        <div class="skeleton-right">
          <div class="shimmer" style="width: 80px; height: 32px; border-radius: 16px;"></div>
          <div class="shimmer" style="width: 80px; height: 32px; border-radius: 16px;"></div>
        </div>
      </div>
    `;
    this.updateStickyState();
  }

  private isMenuItemVisible(item: HeaderMenuItem): boolean {
    if (item.hidden || item.enabled === false) return false;
    if (item.auth === 'guest' && this.session.authenticated) return false;
    if (item.auth === 'authenticated' && !this.session.authenticated) return false;
    const device = this.isMobileViewport() ? 'mobile' : 'desktop';
    if (item.devices?.length && !item.devices.includes(device)) return false;
    if (item.activeAppIds?.length && !item.activeAppIds.includes(this.appId)) return false;
    const now = Date.now();
    if (item.startAt && Date.parse(item.startAt) > now) return false;
    if (item.endAt && Date.parse(item.endAt) <= now) return false;
    return true;
  }

  private visibleMenuItems(items: HeaderMenuItem[] = []): HeaderMenuItem[] {
    return items
      .filter((item) => this.isMenuItemVisible(item))
      .map((item) => ({ ...item, children: this.visibleMenuItems(item.children || []) }));
  }

  private isDividerItem(item: HeaderMenuItem): boolean {
    return item.id === 'divider' || item.id.startsWith('divider-');
  }

  private renderBadge(item: HeaderMenuItem): string {
    if (!item.badge) return '';
    const background = item.badgeStyle?.bg ? safeCssColor(item.badgeStyle.bg, '') : '';
    const color = item.badgeStyle?.color ? safeCssColor(item.badgeStyle.color, '') : '';
    const style = [background && `background:${background}`, color && `color:${color}`].filter(Boolean).join(';');
    return `<span class="badge"${style ? ` style="${style}"` : ''}>${escapeHtml(item.badge)}</span>`;
  }

  private renderDropdownItem(item: HeaderMenuItem): string {
    const children = item.children || [];
    if (children.length) {
      return `<div class="dropdown-group">
        <div class="dropdown-column-title">${escapeHtml(item.label)}</div>
        ${children.map((child) => this.renderDropdownItem(child)).join('')}
      </div>`;
    }

    const href = safeUrl(item.href) || '#';
    const target = item.target === '_blank' ? ' target="_blank" rel="noopener noreferrer"' : '';
    const icon = item.icon?.trim().startsWith('<svg')
      ? sanitizeSvg(item.icon)
      : safeUrl(item.icon, false)
        ? `<img src="${escapeHtml(safeUrl(item.icon, false))}" alt="" style="width:18px;height:18px;object-fit:contain" />`
        : '';

    return `<a class="subitem-link" href="${escapeHtml(href)}" data-id="${escapeHtml(item.id)}"${target}>
      ${icon ? `<div class="subitem-icon">${icon}</div>` : ''}
      <div class="subitem-content">
        <div class="subitem-title">${escapeHtml(item.label)}${this.renderBadge(item)}</div>
        ${item.description ? `<div class="subitem-desc">${escapeHtml(item.description)}</div>` : ''}
      </div>
    </a>`;
  }

  private renderMenu(items: HeaderMenuItem[]): string {
    return this.visibleMenuItems(items).map((item) => {
      if (this.isDividerItem(item)) return '<li class="nav-item"><div class="menu-divider"></div></li>';

      const children = item.children || [];
      const hasChildren = children.length > 0;
      const isOpen = this.activeDropdownId === item.id;
      const columnCount = Math.min(4, Math.max(1, item.columnCount || 1));
      const columns: HeaderMenuItem[][] = Array.from({ length: columnCount }, () => []);
      children.forEach((child) => {
        const index = child.columnIndex !== undefined && child.columnIndex >= 0 && child.columnIndex < columnCount
          ? child.columnIndex
          : 0;
        columns[index].push(child);
      });
      const dropdown = hasChildren ? `
        <div class="dropdown-popover ${isOpen ? 'open' : ''}" style="width:${columnCount * 280 + (columnCount - 1) * 16}px;display:flex;gap:16px">
          ${columns.map((column, index) => `<div class="dropdown-column">
            ${item.columnTitles?.[index] ? `<div class="dropdown-column-title">${escapeHtml(item.columnTitles[index])}</div>` : ''}
            ${column.map((child) => this.renderDropdownItem(child)).join('')}
          </div>`).join('')}
        </div>` : '';
      const href = safeUrl(item.href) || '#';
      const target = item.target === '_blank' ? ' target="_blank" rel="noopener noreferrer"' : '';

      return `<li class="nav-item" data-id="${escapeHtml(item.id)}">
        <a class="nav-link ${isOpen ? 'active' : ''}" href="${escapeHtml(href)}" data-id="${escapeHtml(item.id)}" data-has-children="${hasChildren}"${target}>
          ${escapeHtml(item.label)}${this.renderBadge(item)}
          ${hasChildren ? '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 9l6 6 6-6"/></svg>' : ''}
        </a>
        ${dropdown}
      </li>`;
    }).join('');
  }

  private scheduleVisibilityRefresh(items: HeaderMenuItem[]) {
    if (this.visibilityTimer !== null) window.clearTimeout(this.visibilityTimer);
    const now = Date.now();
    const times: number[] = [];
    const visit = (menuItems: HeaderMenuItem[]) => {
      menuItems.forEach((item) => {
        for (const value of [item.startAt, item.endAt]) {
          const timestamp = value ? Date.parse(value) : Number.NaN;
          if (Number.isFinite(timestamp) && timestamp > now) times.push(timestamp);
        }
        visit(item.children || []);
      });
    };
    visit(items);
    const next = Math.min(...times);
    if (Number.isFinite(next)) {
      this.visibilityTimer = window.setTimeout(() => {
        this.render();
        this.setupListeners();
      }, Math.min(next - now + 50, 2_147_000_000));
    }
  }

  private render() {
    const isDark = this.theme === 'dark';
    const items = (this.config.variants && this.config.variants[this.variant]) || [];
    this.scheduleVisibilityRefresh(items);

    const themedLogo = isDark ? this.logoDark : this.logoLight;
    const logoVal = themedLogo || this.logo;
    const builtinLightLogo = !isDark && !themedLogo ? BUILTIN_LIGHT_LOGOS.get(this.logo) : undefined;
    const baseDomain = new URL(import.meta.url).origin;
    const customLogoUrl = safeUrl(logoVal, false);
    const safeLogoName = /^[\w -]{1,80}$/.test(logoVal) ? logoVal : 'VidAU';
    const logoUrl = builtinLightLogo
      ? `${baseDomain}/logos/${encodeURIComponent(builtinLightLogo)}`
      : customLogoUrl
        ? customLogoUrl
        : logoVal.startsWith('/')
          ? safeUrl(`${baseDomain}${logoVal}`, false)
          : `${baseDomain}/logos/${encodeURIComponent(safeLogoName)}.png`;

    const styles = `
      <style>
        ${this.getHostLayoutStyles()}
        :host {
          --bg-primary: ${isDark ? '#0a0d12' : '#ffffff'};
          --bg-surface: ${isDark ? '#161822' : '#f8f9fc'};
          --bg-hover: ${isDark ? '#202434' : '#eef1f8'};
          --text-primary: ${isDark ? '#ffffff' : '#0f172a'};
          --text-secondary: ${isDark ? '#94a3b8' : '#64748b'};
          --border-color: ${isDark ? '#26293b' : '#e2e8f0'};
          --accent-purple: #7c3aed;
          --accent-gradient: linear-gradient(135deg, #7c3aed 0%, #a855f7 100%);
          --badge-bg: rgba(124, 58, 237, 0.15);
          --badge-text: #a855f7;

          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          color: var(--text-primary);
        }

        *, *:before, *:after { box-sizing: border-box; }

        .header-container {
          width: 100%;
          max-width: var(--header-max-width, 100%);
          margin: 0 auto;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          padding: var(--header-padding, 0 40px);
          box-sizing: border-box;
        }

        .logo {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          text-decoration: none;
        }

        .logo-img {
          height: 17px;
          width: auto;
          object-fit: contain;
          ${!isDark && !themedLogo && !builtinLightLogo ? 'filter: brightness(0);' : ''}
        }

        .left-section {
          flex: 1;
          min-width: 0;
          height: 100%;
          display: flex;
          align-items: center;
          gap: 30px;
        }

        .nav-list {
          display: flex;
          align-items: center;
          gap: 15px;
          list-style: none;
          margin: 0;
          padding: 0;
          height: 100%;
          flex-wrap: nowrap;
          overflow-x: auto;
          overflow-y: hidden;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: none;
        }

        .nav-list::-webkit-scrollbar {
          display: none;
        }

        .nav-item {
          flex-shrink: 0;
          position: relative;
          display: flex;
          align-items: center;
          height: 100%;
        }

        .nav-link {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: var(--text-primary);
          text-decoration: none;
          transition: color 0.2s ease;
          cursor: pointer;
          white-space: nowrap;
        }

        .nav-link:hover {
          color: var(--text-secondary);
        }

        .nav-link.active {
          color: #B099FF;
        }

        .badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 28px;
          height: 14px;
          padding: 0 4px;
          border-radius: 4px;
          background: rgba(255, 45, 158, 0.16);
          color: #ff2d9e;
          font-size: 10px;
          font-weight: 700;
          font-style: normal;
          line-height: 18px;
          text-transform: none;
        }

        .badge.top {
          background: #FF1A75;
          color: #ffffff;
          font-size: 8px;
        }

        .menu-divider {
          width: 1px;
          height: 23px;
          background: #535862;
        }

        /* 下拉 Popover 框 */
        .dropdown-popover {
          position: absolute;
          top: calc(100% + 2px);
          left: 0;
          z-index: 99999;
          background: var(--bg-surface);
          border: 1px solid var(--border-color);
          border-radius: 12px;
          padding: 12px;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.3), 0 8px 10px -6px rgba(0, 0, 0, 0.2);
          opacity: 0;
          visibility: hidden;
          transform: translateY(-8px);
          transition: opacity 0.2s cubic-bezier(0.16, 1, 0.3, 1), transform 0.2s cubic-bezier(0.16, 1, 0.3, 1), visibility 0.2s cubic-bezier(0.16, 1, 0.3, 1);
          pointer-events: none;
        }

        .dropdown-popover.open {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
          pointer-events: auto;
        }

        .dropdown-column {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .dropdown-column-title {
          font-size: 11px;
          color: var(--text-secondary);
          font-weight: 600;
          margin-bottom: 8px;
          padding-left: 12px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .subitem-link {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 10px 12px;
          border-radius: 8px;
          text-decoration: none;
          color: var(--text-primary);
          transition: background 0.15s ease;
        }

        .subitem-link:hover {
          background: var(--bg-hover);
        }

        .subitem-icon {
          position: relative;
          flex-shrink: 0;
          width: 32px;
          height: 32px;
          border-radius: 8px;
          background: var(--bg-hover);
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--text-primary);
        }

        .subitem-icon svg {
          width: 16px;
          height: 16px;
        }

        .subitem-content {
          flex: 1;
          min-width: 0;
        }

        .subitem-title {
          font-size: 13px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 6px;
          line-height: 1.3;
        }

        .subitem-desc {
          font-size: 11px;
          color: var(--text-secondary);
          margin-top: 4px;
          line-height: 1.4;
        }

        /* 右侧操作区 */
        .right-section {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .auth-buttons {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .pricing-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: visible;
        }

        .pricing-btn {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          height: 30px;
          padding: 0 16px;
          border-radius: 8px;
          background: ${isDark ? '#252b37' : '#f5f5f5'};
          color: ${isDark ? '#ffffff' : '#181d27'};
          font-family: inherit;
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          text-decoration: none;
          border: none;
          cursor: pointer;
          white-space: nowrap;
        }

        .pricing-btn:hover {
          background: var(--bg-hover);
        }

        .pricing-tag-icon {
          width: 16px;
          height: 16px;
          flex-shrink: 0;
        }

        .pricing-badge {
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #ff2d9e;
          color: #ffffff;
          font-size: 12px;
          font-weight: 500;
          line-height: 18px;
          padding: 2px 8px;
          border-radius: 9999px;
          white-space: nowrap;
          pointer-events: none;
        }

        .divider-line {
          width: 1px;
          height: 28px;
          background: #535862;
        }

        .btn {
          height: 30px;
          padding: 0 16px;
          border-radius: 8px;
          font-family: inherit;
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          cursor: pointer;
          transition: all 0.2s ease;
          border: none;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          white-space: nowrap;
        }

        .btn-login {
          min-width: 73px;
          background: ${isDark ? '#252b37' : '#f5f5f5'};
          color: ${isDark ? '#ffffff' : '#181d27'};
        }

        .btn-login:hover {
          background: var(--bg-hover);
        }

        .btn-signup {
          min-width: 92px;
          padding: 0 12px;
          border-radius: 10px;
          background: #6a3bff;
          color: #ffffff;
        }

        .btn-signup:hover {
          opacity: 0.9;
        }

        .user-profile {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .user-name {
          font-size: 14px;
          color: var(--text-primary);
          font-weight: 500;
        }

        .user-avatar-btn {
          width: 32px;
          height: 32px;
          border-radius: 99px;
          background: #7c3aed;
          color: #ffffff;
          font-weight: 700;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          padding: 0;
        }

        .user-avatar-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 99px;
        }

        /* 登录后的积分、礼物与用户下拉 */
        .header-action-anchor,
        .user-profile {
          position: relative;
          display: flex;
          align-items: center;
        }

        .credits-btn {
          height: 36px;
          padding: 0 12px;
          border-radius: 6px;
          background: #6a3bff;
          color: #ffffff;
          font-size: 14px;
          font-weight: 600;
          border: none;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          cursor: pointer;
        }

        .credits-button-icon {
          width: 20px;
          height: 20px;
          display: block;
          flex: none;
        }

        .gift-btn {
          height: 36px;
          width: 36px;
          border-radius: 6px;
          background: transparent;
          border: none;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          padding: 6px;
        }
        .gift-btn svg { width: 24px; height: 24px; }
        .gift-btn:hover { background: var(--bg-hover); }

        .header-account-popover {
          position: absolute;
          top: calc(100% + 31px);
          right: 0;
          background: var(--bg-surface);
          border: 1px solid var(--border-color);
          border-radius: 12px;
          box-shadow: 0 4px 10.45px rgba(0, 0, 0, 0.25);
          opacity: 0;
          visibility: hidden;
          transform: translateY(-8px);
          transition: opacity 0.2s cubic-bezier(0.16, 1, 0.3, 1), transform 0.2s cubic-bezier(0.16, 1, 0.3, 1), visibility 0.2s;
          pointer-events: none;
          z-index: 1000;
        }

        .header-account-popover::before {
          content: '';
          position: absolute;
          top: -12px;
          right: 16px;
          width: 24px;
          height: 18px;
          background: var(--bg-surface);
          clip-path: polygon(50% 0, 100% 100%, 0 100%);
        }

        .header-account-popover.open {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
          pointer-events: auto;
        }

        .credits-dropdown {
          width: 272px;
          padding: 16px;
        }

        .gift-dropdown {
          width: 340px;
          padding: 16px;
        }

        .credits-dropdown {
          display: flex;
          flex-direction: column;
          gap: 16px;
          right: -6px;
        }

        .gift-dropdown {
          right: -6px;
        }

        .credits-plan {
          display: flex;
          flex-direction: column;
          gap: 5px;
        }

        .credits-plan-heading,
        .gift-heading {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .gift-copy {
          min-width: 0;
          overflow-wrap: break-word;
        }

        .credits-plan-icon {
          width: 40px;
          height: 40px;
          border-radius: 8px;
          background: #f5f7ff;
          border: 1px solid #fdfdfd;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 1px 2px rgba(10, 13, 18, 0.12), inset 0 -2px rgba(10, 13, 18, 0.05);
          flex: none;
        }

        .credits-plan-title,
        .gift-title {
          color: var(--text-primary);
          font-size: 18px;
          line-height: 28px;
          font-weight: 600;
        }

        .popover-muted {
          color: var(--text-secondary);
          font-size: 14px;
          line-height: 20px;
        }

        .credit-usage-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          color: var(--text-secondary);
          font-size: 14px;
          line-height: 20px;
          font-weight: 500;
        }

        .credit-left {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          white-space: nowrap;
        }

        .credit-chevron {
          font-size: 20px;
          line-height: 13px;
        }

        .progress-dotted {
          --progress: 0%;
          width: 100%;
          height: 5px;
          margin-top: 5px;
          position: relative;
          overflow: hidden;
          background-image: radial-gradient(circle, #525866 2.28px, transparent 2.4px);
          background-size: 6.4px 5px;
          background-position: left center;
          background-repeat: repeat-x;
        }

        .progress-dotted::after {
          content: '';
          position: absolute;
          inset: 0 auto 0 0;
          width: var(--progress);
          background-image: radial-gradient(circle, #ff2d9e 2.28px, transparent 2.4px);
          background-size: 6.4px 5px;
          background-position: left center;
          background-repeat: repeat-x;
        }

        .upgrade-now-btn,
        .claim-credits-btn {
          width: 100%;
          height: 36px;
          border-radius: 8px;
          background: #6a3bff;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: 600;
          text-decoration: none;
        }

        .gift-heading { margin-bottom: 16px; }
        .gift-heading > svg { width: 40px; height: 40px; flex: none; }
        .gift-copy { min-width: 0; flex: 1; }
        .gift-subtitle { white-space: normal; overflow-wrap: break-word; word-break: break-word; }

        .user-dropdown-popover {
          position: absolute;
          top: calc(100% + 12px);
          right: 8px;
          left: auto;
          width: min(345px, calc(100% - 16px));
          max-width: calc(100% - 16px);
          padding: 0;
          overflow: hidden;
        }

        .user-dropdown-popover.open {
          transform: none;
        }

        .user-dropdown-header {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 20px 10px 0;
          margin-bottom: 17px;
        }

        .user-info-text {
          display: flex;
          flex-direction: column;
        }

        .user-name {
          font-size: 16px;
          line-height: 24px;
          color: var(--text-primary);
          font-weight: 600;
        }

        .user-plan {
          font-size: 12px;
          line-height: 18px;
          color: var(--text-secondary);
        }

        .user-dropdown-credits {
          background: var(--bg-hover);
          border-radius: 16px;
          height: 115px;
          padding: 20px 17px 10px 10px;
          margin: 0 10px 0;
        }

        .credits-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          line-height: 20px;
          color: var(--text-secondary);
          font-weight: 500;
        }

        .credits-left {
          font-size: 14px;
          color: var(--text-secondary);
        }

        .credits-upgrade {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid var(--border-color);
          padding-top: 10px;
          margin-top: 10px;
        }

        .premium-text {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 14px;
          color: var(--text-secondary);
          font-weight: 500;
        }

        .premium-icon { width: 24px; height: 16px; display: block; }

        .btn-upgrade {
          background: #ff2d9e;
          color: #ffffff;
          height: 25px;
          padding: 0 14px;
          border-radius: 99px;
          font-size: 12px;
          line-height: 18px;
          font-weight: 600;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
        }

        .user-dropdown-menu {
          display: flex;
          flex-direction: column;
          padding-top: 5px;
        }

        .menu-action-btn {
          display: flex;
          align-items: center;
          gap: 10px;
          height: 40px;
          padding: 5px 20px;
          background: transparent;
          border: none;
          color: var(--text-secondary);
          font-size: 14px;
          line-height: 20px;
          font-weight: 500;
          text-decoration: none;
          cursor: pointer;
          text-align: left;
        }
        .menu-action-icon { width: 16px; height: 16px; flex: none; display: block; }
        .menu-action-btn:hover {
          background: var(--bg-hover);
        }
        .menu-action-divider {
          height: 1px;
          background: var(--border-color);
          margin: 5px 0 0;
        }
        .logout-action { height: 50px; }
        .mobile-menu-trigger {
          display: none;
          background: transparent;
          border: none;
          color: var(--text-primary);
          cursor: pointer;
          padding: 4px;
          margin-left: 8px;
        }

        .mobile-menu-overlay {
          display: none;
          position: fixed;
          top: var(--header-overlay-top, var(--header-height));
          left: 0;
          width: 100%;
          height: calc(100dvh - var(--header-overlay-top, var(--header-height)));
          background: var(--bg-primary);
          z-index: 2147483646;
          overflow-y: auto;
          flex-direction: column;
          padding: 16px 24px;
          box-sizing: border-box;
        }

        .mobile-menu-overlay.open {
          display: block;
        }

        .mobile-nav-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
        }

        .mobile-menu-overlay .nav-item {
          width: 100%;
          height: auto;
          border-bottom: 1px solid var(--border-color);
        }

        .mobile-menu-overlay .menu-divider {
          display: none;
        }

        .mobile-menu-overlay .nav-link {
          display: flex;
          align-items: center;
          width: 100%;
          padding: 16px 0;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: var(--text-primary);
          justify-content: space-between;
        }

        .mobile-menu-overlay .dropdown-popover {
          display: none !important;
        }

        .mobile-menu-overlay .dropdown-popover.mobile-open {
          display: flex !important;
          flex-direction: column !important;
          gap: 0 !important;
          position: static;
          width: 100% !important;
          transform: none;
          box-shadow: none;
          border: none;
          background: transparent;
          padding: 0;
          opacity: 1;
          visibility: visible;
          pointer-events: auto;
          margin-top: 8px;
        }

        .mobile-menu-overlay .dropdown-column {
          width: 100% !important;
          margin-bottom: 8px;
        }

        :host([data-stuck]) .pricing-badge {
          top: calc(100% + 1px);
          font-size: 10px;
          line-height: 14px;
          padding: 0 6px;
        }
        :host([data-stuck]) .pricing-btn,
        :host([data-stuck]) .auth-buttons .btn { font-size: 14px; line-height: 20px; }
        :host([data-stuck]) .auth-buttons .btn { height: 26px; }
        :host([data-stuck]) .right-section .user-avatar-btn { width: 28px; height: 28px; }
        :host([data-stuck]) .credits-btn { height: 28px; }
        :host([data-stuck]) .gift-btn { width: 28px; height: 28px; padding: 4px; }
        :host([data-stuck]) .gift-btn svg { width: 20px; height: 20px; }
        :host([data-stuck]) .divider-line { height: 24px; }

        @media (max-width: 1366px) {
          .nav-list { gap: 12px; }
          .left-section { gap: 24px; }
          .header-container { padding: 0 32px; }
        }

        @media (max-width: 1024px) {
          .nav-list { gap: 10px; }
          .nav-link { font-size: 13px; }
          .left-section { gap: 16px; }
          .header-container { padding: 0 24px; gap: 16px; }
          .right-section { gap: 12px; }
        }

        @media (max-width: 768px) {
          .nav-list { display: none; }
          .mobile-menu-trigger { display: flex; align-items: center; justify-content: center; }
          .user-dropdown-popover {
            right: 8px;
            left: auto;
            width: min(345px, calc(100% - 16px));
            max-width: calc(100% - 16px);
          }
        }

        @media (max-width: 500px) {
          .pricing-wrapper { display: none; }
          .gift-btn { display: none; }
          .header-container { padding: 0 16px; gap: 16px; }
          .right-section { gap: 10px; }
        }
      </style>
    `;

    const navItemsHtml = this.renderMenu(items);

    const isProdEnv = window.location.hostname.indexOf('vidau.ai') > -1;
    const siteBaseUrl = isProdEnv ? 'https://www.vidau.ai' : 'https://www.vidau.info';
    const profileUrl = `${siteBaseUrl}/profile`;
    const pricingUrl = `${siteBaseUrl}/pricing`;
    const rawCredits = Number(this.session.user?.credits ?? 0);
    const creditsValue = Number.isFinite(rawCredits) ? rawCredits : 0;
    const rawTotalCredits = Number(this.session.user?.totalCredits ?? creditsValue);
    const totalCredits = Number.isFinite(rawTotalCredits) && rawTotalCredits > 0
      ? Math.max(rawTotalCredits, creditsValue)
      : creditsValue;
    const rawSpentCredits = Number(this.session.user?.spentCredits ?? Math.max(totalCredits - creditsValue, 0));
    const spentCredits = Number.isFinite(rawSpentCredits) ? Math.max(rawSpentCredits, 0) : 0;
    const creditProgress = totalCredits > 0
      ? Math.max(0, Math.min(100, Math.round((creditsValue / totalCredits) * 100)))
      : 0;
    const creditNumber = (value: number) => new Intl.NumberFormat('en-US', {
      notation: value >= 10000 ? 'compact' : 'standard',
      maximumFractionDigits: 1,
    }).format(value);
    const creditExpiry = escapeHtml(this.session.user?.creditsExpireAt || '—');
    const displayName = escapeHtml(this.session.user?.displayName || 'User');
    const displayPlan = escapeHtml(this.session.user?.plan || 'Free Plan');
    const avatarUrl = safeUrl(this.session.user?.avatarUrl, false);

    const authAreaHtml = this.session.authenticated
      ? `
        <div class="header-action-anchor">
          <button type="button" class="credits-btn" id="credits-trigger" aria-label="Open credit details" aria-haspopup="dialog" aria-expanded="false">
            ${creditNumber(creditsValue)}
            ${FIGMA_COINS_ICON}
          </button>
          <div class="header-account-popover credits-dropdown" id="credits-dropdown">
            <div class="credits-plan">
              <div class="credits-plan-heading">
                <span class="credits-plan-icon">${FIGMA_PLAN_ICON}</span>
                <span class="credits-plan-title">${displayPlan}</span>
              </div>
              <div class="popover-muted">Expires: ${creditExpiry}</div>
            </div>
            <div>
              <div class="credit-usage-row">
                <span>Spent ${creditNumber(spentCredits)}</span>
                <span class="credit-left">${creditNumber(creditsValue)} left <span class="credit-chevron">›</span></span>
              </div>
              <div class="progress-dotted" style="--progress: ${creditProgress}%"></div>
            </div>
            <div>
              <div class="popover-muted" style="margin-bottom: 6px">Expires: ${creditExpiry}</div>
              <a href="${pricingUrl}" class="header-popover-link upgrade-now-btn" data-action="open-pricing" data-pricing-source="credits-popover">Upgrade now</a>
            </div>
          </div>
        </div>
        <div class="header-action-anchor">
          <button type="button" class="gift-btn" id="gift-trigger" aria-label="Open free credits" aria-haspopup="dialog" aria-expanded="false">
            ${FIGMA_GIFT_ICON}
          </button>
          <div class="header-account-popover gift-dropdown" id="gift-dropdown">
            <div class="gift-heading">
              ${FIGMA_GIFT_ICON}
              <div class="gift-copy">
                <div class="gift-title">GET 30% OFF YOUR FIRST MONTH</div>
                <div class="popover-muted gift-subtitle">Join the VidAU Discord to unlock your discount.</div>
              </div>
            </div>
            <a href="https://discord.com/invite/PKz5mfgmPt" target="_blank" rel="noopener noreferrer" class="header-popover-link claim-credits-btn">Claim Discount</a>
          </div>
        </div>
        <div class="divider-line"></div>
        <div class="user-profile">
          <button type="button" class="user-avatar-btn" id="user-avatar-trigger" title="${displayName}" aria-label="Open user menu" aria-haspopup="menu" aria-expanded="false">
            ${avatarUrl
        ? `<img src="${escapeHtml(avatarUrl)}" alt="Avatar" class="user-avatar-img" />`
        : escapeHtml((this.session.user?.displayName || 'U').charAt(0).toUpperCase())
      }
          </button>
        </div>
      `
      : `
        <div class="pricing-wrapper">
          <a href="${pricingUrl}" class="pricing-btn">
            Pricing
            <svg class="pricing-tag-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
              <line x1="7" y1="7" x2="7.01" y2="7"></line>
            </svg>
          </a>
          <div class="pricing-badge">30% OFF</div>
        </div>
        <div class="divider-line"></div>
        <div class="auth-buttons">
          <button type="button" id="login-btn" class="btn btn-login">Login</button>
          ${this.config.authUi?.registrationEnabled === false ? '' : '<button type="button" id="signup-btn" class="btn btn-signup">Sign up</button>'}
        </div>
      `;

    const userMenuHtml = this.session.authenticated
      ? `
      <div class="header-account-popover user-dropdown-popover" id="user-dropdown">
        <div class="user-dropdown-header">
          <div class="user-avatar-btn" style="cursor: default">
            ${avatarUrl
        ? `<img src="${escapeHtml(avatarUrl)}" alt="Avatar" class="user-avatar-img" />`
        : escapeHtml((this.session.user?.displayName || 'U').charAt(0).toUpperCase())
      }
          </div>
          <div class="user-info-text">
            <div class="user-name">${displayName}</div>
            <div class="user-plan">${displayPlan}</div>
          </div>
        </div>
        <div class="user-dropdown-credits">
          <div class="credits-title">Credits <span class="credits-left">${creditNumber(creditsValue)} left &gt;</span></div>
          <div class="progress-dotted" style="--progress: ${creditProgress}%"></div>
          <div class="credits-upgrade">
            <span class="premium-text">
              <span class="premium-icon">${FIGMA_CROWN_ICON}</span>
              Go Premium
            </span>
            <a href="${pricingUrl}" class="btn-upgrade" data-action="open-pricing" data-pricing-source="user-menu">Upgrade</a>
          </div>
        </div>
        <div class="user-dropdown-menu">
          <a href="${profileUrl}" class="menu-action-btn">
            <svg class="menu-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
            View profile
          </a>
          <a href="https://discord.com/invite/PKz5mfgmPt" target="_blank" rel="noopener noreferrer" class="menu-action-btn">
            <img class="menu-action-icon" src="${FIGMA_DISCORD_ICON}" alt="" />
            Join Community
          </a>
          <div class="menu-action-divider"></div>
          <button class="menu-action-btn logout-action" id="logout-btn">
            <svg class="menu-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
            Sign Out
          </button>
        </div>
      </div>`
      : '';

    const html = `
      ${styles}
      <header class="header-container">
        <div class="left-section">
          <a href="${siteBaseUrl}" class="logo">
            <img src="${escapeHtml(logoUrl)}" alt="Logo" class="logo-img" />
          </a>
          <ul class="nav-list">
            ${navItemsHtml}
          </ul>
        </div>
        <div class="right-section">
          ${authAreaHtml}
          <button class="mobile-menu-trigger" id="mobile-menu-trigger">
            ${this.isMobileMenuOpen
        ? `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`
        : `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>`
      }
          </button>
        </div>
      </header>
      ${userMenuHtml}

      <div class="mobile-menu-overlay ${this.isMobileMenuOpen ? 'open' : ''}">
        <ul class="mobile-nav-list">
          ${navItemsHtml}
        </ul>
      </div>
    `;

    this.shadow.innerHTML = html;
    this.updateStickyState();
  }

  private setupListeners() {
    this.shadow.querySelector('#login-btn')?.addEventListener('click', () => void this.handleAuthClick('login'));
    this.shadow.querySelector('#signup-btn')?.addEventListener('click', () => void this.handleAuthClick('register'));

    // 移动端汉堡菜单切换
    const mobileMenuTrigger = this.shadow.querySelector('#mobile-menu-trigger');
    if (mobileMenuTrigger) {
      mobileMenuTrigger.addEventListener('click', () => {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
        this.render();
        this.setupListeners();
      });
    }

    // 下拉菜单 Hover/Click 交互
    const navItems = this.shadow.querySelectorAll('.nav-item');
    navItems.forEach((item) => {
      const id = item.getAttribute('data-id');
      const link = item.querySelector('.nav-link');
      const dropdown = item.querySelector('.dropdown-popover') as HTMLElement;
      const hasChildren = link?.getAttribute('data-has-children') === 'true';

      if (hasChildren && id && link && dropdown) {
        item.addEventListener('mouseenter', () => {
          this.activeDropdownId = id;
          link.classList.add('active');

          if (!item.closest('.mobile-menu-overlay')) {
            const rect = item.getBoundingClientRect();
            dropdown.style.position = 'fixed';
            dropdown.style.top = `${rect.bottom + 2}px`;
            dropdown.style.left = `${rect.left}px`;
          }

          dropdown.classList.add('open');
        });

        item.addEventListener('mouseleave', () => {
          if (this.activeDropdownId === id) {
            this.activeDropdownId = null;
          }
          link.classList.remove('active');
          dropdown.classList.remove('open');
        });

        link.addEventListener('click', (e) => {
          if (item.closest('.mobile-menu-overlay')) {
            e.preventDefault();
            e.stopImmediatePropagation();
            dropdown.classList.toggle('mobile-open');
          }
        });
      }
    });

    const navList = this.shadow.querySelector('.nav-list');
    if (navList) {
      navList.addEventListener('scroll', () => {
        if (this.activeDropdownId) {
          const activeItem = Array.from(navItems).find(i => i.getAttribute('data-id') === this.activeDropdownId);
          if (activeItem) {
            activeItem.querySelector('.nav-link')?.classList.remove('active');
            activeItem.querySelector('.dropdown-popover')?.classList.remove('open');
            this.activeDropdownId = null;
          }
        }
      });
    }

    // 监听子项目菜单导航点击
    const links = this.shadow.querySelectorAll('a');
    links.forEach((a) => {
      a.addEventListener('click', (e) => {
        if (a.getAttribute('data-action') === 'open-pricing') {
          if (this.requestPricing(a.getAttribute('data-pricing-source') || 'header')) {
            e.preventDefault();
            return;
          }
        }
        // 对于用户菜单内的直达链接，允许默认跳转（不拦截派发事件）
        if (a.classList.contains('btn-upgrade') || a.classList.contains('menu-action-btn') || a.classList.contains('pricing-btn') || a.classList.contains('header-popover-link')) {
          return;
        }
        const href = a.getAttribute('href');
        const id = a.getAttribute('data-id') || 'link';
        if (href && a.hasAttribute('data-id')) {
          if (this.isMobileMenuOpen) {
            this.isMobileMenuOpen = false;
            this.render();
            this.setupListeners();
          }
          this.dispatchEventCustom('vidau:navigate', {
            id,
            href,
            label: a.textContent?.trim() || '',
            target: a.getAttribute('target') || '_self',
          });
        }
      });
    });

    // 登录后右侧三个下拉互斥显示
    const closeHeaderPopovers = (except?: Element) => {
      this.shadow.querySelectorAll('.header-account-popover.open').forEach((popover) => {
        if (popover !== except) {
          popover.classList.remove('open');
          if (popover.id === 'user-dropdown') this.clearUserMenuPosition(popover as HTMLElement);
        }
      });
    };
    const bindHeaderPopover = (triggerSelector: string, popoverSelector: string) => {
      const trigger = this.shadow.querySelector(triggerSelector);
      const popover = this.shadow.querySelector(popoverSelector) as HTMLElement | null;
      if (!trigger || !popover) return;
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const shouldOpen = !popover.classList.contains('open');
        closeHeaderPopovers(popover);
        popover.classList.toggle('open', shouldOpen);
        trigger.setAttribute('aria-expanded', String(shouldOpen));
        if (shouldOpen && popoverSelector === '#user-dropdown') {
          requestAnimationFrame(() => this.positionUserMenu());
        } else if (popoverSelector === '#user-dropdown') {
          this.clearUserMenuPosition(popover);
        }
      });
      popover.addEventListener('click', (e) => e.stopPropagation());
    };
    bindHeaderPopover('#credits-trigger', '#credits-dropdown');
    bindHeaderPopover('#gift-trigger', '#gift-dropdown');
    bindHeaderPopover('#user-avatar-trigger', '#user-dropdown');

    // 注销按钮点击
    const logoutBtn = this.shadow.querySelector('#logout-btn');
    if (logoutBtn) {
      logoutBtn.addEventListener('click', async () => {
        try {
          this.configureAuth();
          await logoutAuth();
          this.dispatchEventCustom('vidau:logout');
        } catch (error) {
          this.dispatchEventCustom('vidau:error', {
            code: 'LOGOUT_FAILED',
            message: error instanceof Error ? error.message : 'Unable to log out',
          });
        }
      });
    }
  }

  private async handleAuthClick(mode: 'login' | 'register') {
    const appId = this.appId;
    if (!appId) {
      this.dispatchEventCustom('vidau:error', {
        code: 'APP_ID_REQUIRED',
        message: 'The Header SDK requires an app-id to open authentication',
      });
      return;
    }

    this.configureAuth();
    this.dispatchEventCustom('vidau:auth-open', { mode });

    // 动态按需加载与独立登录 SDK 相同的 Auth Dialog 模块
    try {
      if (!customElements.get('vidau-auth-dialog')) {
        await import('../auth-dialog/vidau-auth-dialog');
      }
      let dialogEl = document.querySelector('vidau-auth-dialog') as AuthDialogElement | null;
      if (!dialogEl) {
        dialogEl = document.createElement('vidau-auth-dialog') as AuthDialogElement;
      }
      dialogEl.setAttribute('app-id', appId);
      dialogEl.setAttribute('redirect-url', window.location.href);
      if (!dialogEl.isConnected) document.body.appendChild(dialogEl);
      if (typeof dialogEl.open === 'function') {
        dialogEl.configure?.({
          providers: this.config.authUi?.providers,
          registrationEnabled: this.config.authUi?.registrationEnabled,
          privacyUrl: this.config.authUi?.privacyUrl,
          termsUrl: this.config.authUi?.termsUrl,
        });
        dialogEl.removeEventListener('vidau:auth-success', this.handleDialogSuccess);
        dialogEl.addEventListener('vidau:auth-success', this.handleDialogSuccess);
        dialogEl.open(mode);
      }
    } catch (err) {
      console.error('[VidAU Header SDK] Failed to load auth dialog bundle:', err);
      this.dispatchEventCustom('vidau:error', {
        code: 'AUTH_DIALOG_LOAD_FAILED',
        message: err instanceof Error ? err.message : 'Unable to open the authentication dialog',
      });
    }
  }

  private handleDialogSuccess = async (event: Event) => {
    const detail = (event as CustomEvent<{ token?: string }>).detail;
    const session = await this.refreshSessionAfterChange();
    if (session.user) this.dispatchEventCustom('vidau:auth-success', { user: session.user, token: detail?.token });
  };
}

// 自动注册 Custom Element
if (!customElements.get('vidau-header')) {
  customElements.define('vidau-header', VidauHeader);
}
